if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.filterMediaBySelectedColor = this.filterMediaBySelectedColor.bind(this);
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

       if (this.elements.thumbnails) {
  this.elements.viewer.addEventListener(
    'slideChanged',
    debounce(this.onSlideChanged.bind(this), 500)
  );

  this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
    mediaToSwitch
      .querySelector('button')
      .addEventListener(
        'click',
        this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
      );
  });

  if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
    this.removeListSemantic();
  }
}
        // SOCALI fix (colour filter, see filterMediaBySelectedColor): when Dawn has finished a variant change
        // (it may have added the chosen variant's photo to the gallery), check the photos again
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, () => this.socaliRecheck());
        }
        requestAnimationFrame(() => {
  this.filterMediaBySelectedColor();
});

document.addEventListener('change', (event) => {
  const target = event.target;

  if (
    target.matches('input[type="radio"]') ||
    target.matches('select')
  ) {
    this.socaliChanged = true; // SOCALI fix: this filter run follows an option change (see the filter)
    requestAnimationFrame(() => {
      this.filterMediaBySelectedColor();
    });
  }
});
}

filterMediaBySelectedColor() {
  const productSection = this.closest('.shopify-section');
  if (!productSection) return;

  const colorFieldset = Array.from(
    productSection.querySelectorAll('fieldset')
  ).find((fieldset) => {
    const legend = fieldset.querySelector('legend');
    return legend && legend.textContent.trim().toLowerCase().startsWith('color');
  });

  let selectedColor = null;

  if (colorFieldset) {
    const checkedInput = colorFieldset.querySelector('input:checked');
    if (checkedInput) {
      selectedColor = checkedInput.value.trim().toLowerCase();
    }
  }

  if (!selectedColor) {
    const selects = productSection.querySelectorAll('select');

    for (const select of selects) {
      const label =
        productSection.querySelector(`label[for="${select.id}"]`)?.textContent || '';

      if (label.trim().toLowerCase().startsWith('color')) {
        selectedColor = select.value.trim().toLowerCase();
        break;
      }
    }
  }

  if (!selectedColor) return;

  const mediaItems =
    this.elements.viewer.querySelectorAll('[data-media-color]');
  // SOCALI fix: what is shown before the live rule runs (it may have to stay, see below)
  const socaliShownBefore = this.socaliFlags();

  mediaItems.forEach((item) => {
    const mediaColor = (item.dataset.mediaColor || '')
      .trim()
      .toLowerCase();

    item.hidden = mediaColor !== selectedColor;
  });

  if (this.elements.thumbnails) {
    const thumbnailItems =
      this.elements.thumbnails.querySelectorAll('[data-media-color]');

    thumbnailItems.forEach((item) => {
      const mediaColor = (item.dataset.mediaColor || '')
        .trim()
        .toLowerCase();

      item.hidden = mediaColor !== selectedColor;
    });
  }

  // SOCALI fix: the rule above is the live one, unchanged. When it leaves no photo of the main list:
  // - on load: hide none of them (items without data-media-color, like the box photo, are never touched);
  // - after an option change: Dawn is still loading the chosen variant and may add its photo to the gallery.
  //   Keep the photos shown until Dawn is done; then socaliRecheck() applies the same rule again.
  this.socaliColor = selectedColor;
  this.socaliRemember();
  const socaliAfterChange = this.socaliChanged === true;
  this.socaliChanged = false;
  clearTimeout(this.socaliTimer);
  if (!Array.from(mediaItems).some((item) => !item.hidden)) {
    if (socaliAfterChange) {
      socaliShownBefore.forEach(([item, hidden]) => {
        item.hidden = hidden;
      });
      // in case Dawn never finishes (for example a combination that does not exist)
      this.socaliTimer = setTimeout(() => this.socaliRecheck(), 2000);
      return;
    }
    this.socaliShowAll();
  }

  const firstVisibleMedia = Array.from(mediaItems).find(
    (item) => !item.hidden
  );

  if (firstVisibleMedia) {
    this.elements.viewer
      .querySelectorAll('[data-media-id]')
      .forEach((item) => item.classList.remove('is-active'));

    firstVisibleMedia.classList.add('is-active');

    if (this.elements.viewer.slider) {
      this.elements.viewer.resetPages();
    }

    if (this.elements.thumbnails?.slider) {
      this.elements.thumbnails.resetPages();
    }
  }
}

// SOCALI fix: helpers of the colour filter fix
socaliItems() {
  const items = Array.from(this.elements.viewer.querySelectorAll('[data-media-color]'));

  if (this.elements.thumbnails) {
    items.push(...this.elements.thumbnails.querySelectorAll('[data-media-color]'));
  }

  return items;
}

socaliFlags() {
  return this.socaliItems().map((item) => [item, item.hidden]);
}

socaliRemember() {
  this.socaliSeen = this.socaliSeen || new WeakSet();
  this.socaliItems().forEach((item) => this.socaliSeen.add(item));
}

socaliShowAll() {
  this.socaliItems().forEach((item) => {
    item.hidden = false;
  });
}

// Runs when Dawn has finished a variant change, or 2 seconds after an option change that Dawn did not finish.
// Every photo the filter has already seen gets the live rule again; a photo Dawn added since then stays shown, as on
// the live shop. If that leaves no photo of the main list, every photo is shown.
socaliRecheck() {
  clearTimeout(this.socaliTimer);
  if (!this.socaliSeen || !this.socaliColor) return;

  const before = this.socaliFlags();

  before.forEach(([item]) => {
    if (this.socaliSeen.has(item)) {
      item.hidden = (item.dataset.mediaColor || '').trim().toLowerCase() !== this.socaliColor;
    }
  });

  const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-color]'));

  if (!mediaItems.some((item) => !item.hidden)) {
    this.socaliShowAll();
  }

  if (before.every(([item, hidden]) => item.hidden === hidden)) return;

  const firstVisibleMedia = mediaItems.find((item) => !item.hidden);

  if (firstVisibleMedia) {
    this.elements.viewer
      .querySelectorAll('[data-media-id]')
      .forEach((item) => item.classList.remove('is-active'));

    firstVisibleMedia.classList.add('is-active');

    if (this.elements.viewer.slider) {
      this.elements.viewer.resetPages();
    }

    if (this.elements.thumbnails?.slider) {
      this.elements.thumbnails.resetPages();
    }
  }
}

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
